import Modal from 'LuxKit/Modal/Modal'
import * as React from 'react'
import { useIntl } from 'react-intl'
import ReserveForZeroPolicyModalContent from './ReserveForZeroPolicyModalContent'

interface Props {
  isOpen?: boolean
  onClose?: React.MouseEventHandler<HTMLElement>
}

function ReserveForZeroPolicyModal(props: Props) {
  const { isOpen, onClose } = props
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'vhfHInI506uE16_eBsPI',
        defaultMessage: 'Reserve now for free',
      })}
      isOpen={isOpen}
      onClose={onClose}
      height="full"
      tabletHeight="auto"
      subtitle={intl.formatMessage({
        id: 'vL10DWh_mCmiAbtIIymf',
        defaultMessage: 'Reserve a hotel now for free before being charged after 48 hours.',
      })}
      size="L"
    >
      <ReserveForZeroPolicyModalContent />
    </Modal>
  )
}

export default ReserveForZeroPolicyModal
